<div id="team" class="team-area ptb-100">
    <div class="container">
        <div class="section-title">

            <h2>{{ 'alliances.title' | translate }} <span>{{ 'alliances.highlight' | translate }}</span></h2>

        </div>
        <div class="team-slides">
            @if (languageService.currentLang(); as lang) {
            <owl-carousel-o [options]="teamSlides">
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/images/02logountelcom.png" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">Untel</h3>
                            <a href="https://www.untel.com.tr/" target="_blank"><span class="post">www.untel.com.tr</span></a>
                        </div>
                        <div class="social">
                            <ul>
                                <li>{{ 'alliances.untel' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/images/04logoALUDERCOM.png" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">Aluder</h3>
                            <a href="https://www.aluder.com/" target="_blank"><span class="post">www.aluder.com</span></a>
                        </div>
                        <div class="social">
                            <ul>
                                <li>{{ 'alliances.aluder' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/images/03logoT4RLCOM.png" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">T4RL</h3>
                            <a href="https://www.t4rl.com/" target="_blank"><span class="post">www.t4rl.com</span></a>
                        </div>
                        <div class="social">
                            <ul>
                                <li>{{ 'alliances.t4rl' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-team-box">
                        <div class="image">
                            <img src="assets/images/01logoT-DXCOM.png" alt="team-img">
                        </div>
                        <div class="content">
                            <h3 class="title">Taurus</h3>
                            <a href="https://www.t-dx.com/" target="_blank"><span class="post">www.t-dx.com</span></a>
                        </div>
                        <div class="social">
                            <ul>
                                <li>{{ 'alliances.taurus' | translate }}</li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
            }
        </div>
    </div>
    <div class="shape1"><img src="assets/img/shape1.png" alt="image"></div>
</div>
